export function columnsBankAccounts(t) {
  return [
    {
      id: 'currency_code.currency_code',
      label: t('column.currency_code'),
      minWidth: 30,
      maxWidth: 110,
      align: 'left',
    },
    {
      id: 'iban_number',
      label: t('column.iban'),
      minWidth: 150,
      maxWidth: 170,
      align: 'left',
    },
    {
      id: 'bank_name',
      label: t('column.bank_name'),
      minWidth: 150,
      maxWidth: 170,
      align: 'left',
    },
    {
      id: 'bank_address',
      label: t('column.bank_address'),
      minWidth: 110,
      maxWidth: 150,
      align: 'left',
    },
    {
      id: 'bank_code',
      label: t('column.bank_code'),
      minWidth: 140,
      maxWidth: 170,
      align: 'left',
    },
  ];
}
